import { useReveal } from "@/hooks/useReveal";
import { useMetaPixelTracking } from "@/hooks/useMetaPixelTracking";
import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import QuickInfo from "@/pages/home/components/QuickInfo";
import HowToGet from "@/pages/home/components/HowToGet";
import WhatYouFind from "@/pages/home/components/WhatYouFind";
import ProductSection from "@/pages/home/components/ProductSection";
import Reviews from "@/pages/home/components/Reviews";
import WhyIokus from "@/pages/home/components/WhyIokus";
import Shipping from "@/pages/home/components/Shipping";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";
import MobileBar from "@/pages/home/components/MobileBar";
import type { ProductItem } from "@/pages/home/types";
import { familyGames } from "@/mocks/familyGames";
import { kidsToys } from "@/mocks/kidsToys";
import { CATALOG_URL } from "@/pages/home/constants";
import { withUtm } from "@/utils/shopUrl";

export default function Home() {
  useReveal();
  useMetaPixelTracking();

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Header />
      <main>
        <Hero />
        <QuickInfo />
        <HowToGet />
        <WhatYouFind />
        <ProductSection
          id="familia"
          eyebrow="Juegos de mesa"
          title="Los juegos que unen a la familia"
          subtitle="Pensados para que abuelos, papás y niños jueguen la misma partida."
          items={familyGames as ProductItem[]}
        />
        <ProductSection
          id="peques"
          background="surface"
          eyebrow="Juguetes de madera"
          title="Para los más pequeños"
          subtitle="Madera reforestada y pinturas no tóxicas. Sin plástico, sin pilas, sin pantallas."
          items={kidsToys as ProductItem[]}
          ctaLabel="Ver todo el catálogo en iokus.co"
          ctaHref={withUtm(CATALOG_URL)}
        />
        <Reviews />
        <WhyIokus />
        <Shipping />
        <Faq />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}